;(function () {
    const comps = document.querySelectorAll('.template--superposed, .template--superposed-middle, .o-about-crafting');
    if (!comps.length) return;

    if (history.scrollRestoration) {
        history.scrollRestoration = 'manual';
    }

    window.addEventListener('beforeunload', () => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        });
    });
})();
